import { withPublicImageUrl } from '@lib/utils/cdn'

import { TryItNowButton } from './try-it-now-button'

import style from './header.module.scss'

const Header = () => {
  return (
    <header className={style.header}>
      <div className={style.headerContainer}>
        <nav>
          <a
            className={style.logoIcon}
            href="/"
            style={{
              backgroundImage: `url(${withPublicImageUrl('superhuman-logo.svg')})`,
            }}
          />
        </nav>
        <TryItNowButton />
      </div>
    </header>
  )
}

export default Header
